const $inject = ['$timeout'];

const lbToasterService = function lbToasterService($timeout) {

  let service = {
    positions: {
      TOP: 'top',
      BOTTOM: 'bottom',
      DEFAULT: 'default'
    },
    message: '',
    isActive: false,
    isLoading: false,
    open: open,
    close: close
  };

  const CLOST_DELAY_MS = 3 * 1000;
  let openTimeout = 0;
  let closeTimeout = 0;

  function open(message, options = {}) {
    close(true);

    options = _.extend({}, {
      position: service.positions.DEFAULT,
      autoHide: true,
      isLoading: false,
      fullWidth: false
    }, options);

    service.position = options.position;
    service.isLoading = options.isLoading;
    service.message = message;
    service.fullWidth = options.fullWidth;

    openTimeout = $timeout(() => {
      service.isActive = true;
    }, 100);

    if(options.autoHide && !options.isLoading) {
      closeTimeout = $timeout(() => {
        close();
      }, CLOST_DELAY_MS);
    }
  }

  function close(canLeaveOpen) {
    $timeout.cancel(openTimeout);
    $timeout.cancel(closeTimeout);

    service.isLoading = false;
    service.isActive = canLeaveOpen ? service.isActive : false;
    service.message = '';
  }

  return service;
};

lbToasterService.$inject = $inject;

export default lbToasterService;


// WEBPACK FOOTER //
// ./src/components/sct/sctToaster/sctToasterService.js